export default {
  welcomeLogin: "欢迎登录",
  transferStationNotice: "注意：訂單信息中一程是長途票，一程是口岸票！",
};
